var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllProductsIcon = function SvgAllProductsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.071 2.143v6.786h6.786V2.857a.716.716 0 0 0-.714-.714zm-2.142 0H2.857a.716.716 0 0 0-.714.714V8.93h6.786zM0 11.07V2.857A2.86 2.86 0 0 1 2.857 0h14.286A2.86 2.86 0 0 1 20 2.857v14.286A2.86 2.86 0 0 1 17.143 20H2.857A2.86 2.86 0 0 1 0 17.143zm17.857 0h-6.786v6.786h6.072a.716.716 0 0 0 .714-.714zM8.93 17.857v-6.786H2.143v6.072c0 .393.321.714.714.714z"
  })));
};
export default SvgAllProductsIcon;